'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_s_Product15__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.nm;
      break;
    }
    case 1: {
      return $thiz.nt;
      break;
    }
    case 2: {
      return $thiz.nu;
      break;
    }
    case 3: {
      return $thiz.nv;
      break;
    }
    case 4: {
      return $thiz.nw;
      break;
    }
    case 5: {
      return $thiz.nx;
      break;
    }
    case 6: {
      return $thiz.ny;
      break;
    }
    case 7: {
      return $thiz.nz;
      break;
    }
    case 8: {
      return $thiz.nA;
      break;
    }
    case 9: {
      return $thiz.nn;
      break;
    }
    case 10: {
      return $thiz.no;
      break;
    }
    case 11: {
      return $thiz.np;
      break;
    }
    case 12: {
      return $thiz.nq;
      break;
    }
    case 13: {
      return $thiz.nr;
      break;
    }
    case 14: {
      return $thiz.ns;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 14)"));
    }
  }
}
export { $f_s_Product15__productElement__I__O as $f_s_Product15__productElement__I__O };
